import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  InputAdornment,
} from "@mui/material";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import TranslateIcon from "@mui/icons-material/Translate";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

export default function AddJobDialog({ open, onClose, onSave }) {
  const [form, setForm] = useState({
    nomFR: "",
    nomEN: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!form.nomFR || !form.nomEN) return;

    try {
      setLoading(true);
      await onSave(form);

      setForm({ nomFR: "", nomEN: "" });
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: 4, overflow: "hidden" },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
          color: "white",
          py: 3,
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <WorkOutlineIcon sx={{ fontSize: 32 }} />
          <Box>
            <Typography variant="h6" fontWeight={700}>
              Add New Job
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Create a new job position
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 4 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          Job Information
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <TextField
          fullWidth
          label="Nom Français"
          value={form.nomFR}
          onChange={(e) => setForm({ ...form, nomFR: e.target.value })}
          sx={{ mb: 3 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TranslateIcon color="primary" />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="English Name"
          value={form.nomEN}
          onChange={(e) => setForm({ ...form, nomEN: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TranslateIcon color="primary" />
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 3, pt: 2, gap: 1 }}>
        <Button
          startIcon={<CloseIcon />}
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 2, minWidth: 120 }}
        >
          Cancel
        </Button>

        <Button
          startIcon={<SaveIcon />}
          variant="contained"
          onClick={handleSave}
          disabled={loading}
          sx={{
            borderRadius: 2,
            minWidth: 120,
            fontWeight: 700,
            boxShadow: 3,
          }}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
